// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"cff55ed3","92":"bfff185d","131":"abcce740","226":"a6fefa96","258":"63f92229","291":"cb970a9c","559":"7bd6dc81","890":"0fa84b74"}[chunkId] + ".js";
};